/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teams_Settings_Tab_Image_ModelsInputs */



/**
* | output |
* | --- |
* | "Image models" |
*
* @param {Teams_Settings_Tab_Image_ModelsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const teams_settings_tab_image_models = /** @type {((inputs?: Teams_Settings_Tab_Image_ModelsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teams_Settings_Tab_Image_ModelsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bildmodelle")
	return /** @type {LocalizedString} */ ("Image models")
});